import { Breakpoints, FontFamily } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export const styledHighlightedBenefitWrapper: SxProps = {
  display: 'none',

  [`@media (min-width:${Breakpoints.sm}px)`]: {
    zIndex: '1',
    width: '100%',
    padding: '4px 14px',
    display: 'flex',
    justifyContent: 'center',
  },
};

export const styledHighlightedBenefitTitle: SxProps = {
  fontFamily: FontFamily.heading,
};
